import { useContext } from 'react';

import { app, media } from 'context';

import { AI_ASSISTANT_DESKTOP_MAX_HEIGHT } from './constants';

export default function useAIAssistantHeight() {
  const { isMobile } = useContext(media);
  const { windowHeight } = useContext(app);

  if (isMobile) {
    return windowHeight;
  }

  return windowHeight > 800 ? AI_ASSISTANT_DESKTOP_MAX_HEIGHT : windowHeight - 96;
}
